import TableComponent from "../../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Column } from "react-table";
import FieldOccurencesState from "../../FieldOccurrences/component/FieldOccurencesState";

interface TableAlertProps {
  dataTable: any[];
  isLoaded: boolean;
}

const TableAlert: FC<TableAlertProps> = ({ dataTable, isLoaded }) => {
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Indicador", accessor: "indicator.name", disableSortBy: true },
      {
        Header: "Medida",
        accessor: "indicator.metric.name",
        disableSortBy: true,
      },
      { Header: "Detalhes", accessor: "description", disableSortBy: true },
      {
        Header: "Estado",
        accessor: "isActive",
        disableSortBy: true,
        Cell: ({ row, value }: any) => {
          return (
            <FieldOccurencesState
              stateValue={row.original.type?.id === 1 ? value : null}
              additionalStyle={{ display: "inline-block" }}
              hasBackground={false}
            />
          );
        },
      },
    ];

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTable]);

  return (
    <TableComponent isLoaded={isLoaded} columns={columns} data={dataTable} />
  );
};

export default TableAlert;
